// vavci-collection.js — Interacciones de la página de colección VAVCI.
//
// - Orden: envía el formulario al cambiar el <select> (en cualquier viewport).
// - Drawer móvil: el botón "Filtros" abre la barra lateral como panel deslizante.
// - Grupos de filtro largos: buscador que acota la lista mientras se escribe.
//
// Los filtros de lista son enlaces nativos (server-side), así que no necesitan JS;
// el rango de precio tiene su propio botón "Aplicar precio". Mejora progresiva: sin
// JS, el <select> conserva su botón "Ordenar" (noscript) y el buscador de los grupos
// simplemente no acota: la lista sigue entera y con su scroll (que es puro CSS).

document.querySelectorAll('[data-vcol]').forEach((root) => {
  // Orden
  const sortForm = root.querySelector('[data-vcol-sortform]');
  const sortSel = root.querySelector('[data-vcol-sort]');
  if (sortForm && sortSel) {
    sortSel.addEventListener('change', () => sortForm.submit());
  }

  // Drawer móvil
  const setOpen = (on) => {
    root.toggleAttribute('data-vcol-filters-open', on);
    document.body.style.overflow = on ? 'hidden' : '';
  };
  const openBtn = root.querySelector('[data-vcol-open]');
  const closeBtn = root.querySelector('[data-vcol-close]');
  const overlay = root.querySelector('[data-vcol-overlay]');
  if (openBtn) openBtn.addEventListener('click', () => setOpen(true));
  if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
  if (overlay) overlay.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.hasAttribute('data-vcol-filters-open')) setOpen(false);
  });

  // ── Buscador dentro de los grupos de filtro largos ──
  // Acota la lista YA PINTADA por el servidor: no hay peticiones ni se toca la URL.
  // Escribir aquí no filtra productos, solo ayuda a encontrar la opción; el filtro
  // de verdad sigue siendo el enlace que se pulsa.
  root.querySelectorAll('[data-vcol-fsearch]').forEach((input) => {
    const group = input.closest('.vcol__fgroup');
    const list = group && group.querySelector('[data-vcol-foptions]');
    if (!list) return;
    const empty = group.querySelector('[data-vcol-fempty]');
    const items = Array.from(list.children);

    // Sin acentos y en minúsculas: quien escribe "arnica" espera encontrar "Árnica",
    // y quien escribe "loreal" espera "L'Oréal". Se calcula una vez, no en cada tecla.
    // \p{Diacritic} en vez del rango U+0300–U+036F: el rango se escribe con
    // caracteres combinantes que en el código fuente son invisibles.
    const norm = (s) => s.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
    const keys = items.map((li) => norm(li.textContent.trim()));

    input.addEventListener('input', () => {
      const q = norm(input.value.trim());
      let visibles = 0;
      items.forEach((li, i) => {
        const coincide = q === '' || keys[i].includes(q);
        li.hidden = !coincide;
        if (coincide) visibles++;
      });
      if (empty) empty.hidden = visibles > 0;
      list.scrollTop = 0; // los resultados se leen desde arriba
    });

    // Al cargar con un filtro ya aplicado el grupo viene abierto, pero la opción
    // activa puede caer fuera del alto visible de la lista (Wella, con 115 marcas,
    // queda al fondo) y parecería que no está marcada. Se acerca a la vista.
    if (list.classList.contains('is-scroll')) {
      const activo = list.querySelector('.vcol__fopt.is-active');
      const li = activo && activo.closest('li');
      // La lista es `position: relative`, así que offsetTop ya es relativo a ella.
      if (li && li.offsetTop > list.clientHeight - li.offsetHeight) {
        list.scrollTop = li.offsetTop - 8;
      }
    }
  });
});
